import React from 'react';
import { gtmPush } from '../../../functions/gtm';
import RadioFieldset from '../../../audi-ui-components/RadioFieldset';
import { PrimaryButton, TextButton } from '../../../audi-ui-components/Button';

class StepLoan extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            loantype: props.loantype || null
        };
    }

    componentDidMount() {
        gtmPush("afsCalculator", "StageLoaded", "AfsCalLoanType");
    }

    onClickNextStep = () => {
        let l = this.state.loantype === "ConsumerLoan" ? "Personal loan" : "Business loan";
        gtmPush("afsCalculator", "Proceed", "AfsCalLoanType", {"LoanType": l});
        this.props.onSubmit({loantype: this.state.loantype});
    }

    render() {
        return (
            <div>
                <RadioFieldset title="What type of loan are you looking for?"
                    options={[
                        { label: 'Personal loan', name: 'loantype', value: 'ConsumerLoan' },
                        { label: 'Business loan', name: 'loantype', value: 'ChattelMortgage' }
                    ]}
                    value={this.state.loantype}
                    onChange={(v) => { this.setState({ loantype: v }); }}
                    theme={this.props.theme === "dark" ? "light" : null}
                />
                <div className="row">
                    <div className="col">
                        <TextButton label="Back" className="back" onClick={this.props.onClickBack} theme={this.props.theme === "dark" ? "light" : null} />
                    </div>
                    <div className="col text-right">
                        <PrimaryButton label="Proceed to repayments" onClick={this.onClickNextStep} theme={this.props.theme === "dark" ? "light" : null} />
                    </div>
                </div>
            </div>
        );
    }
}

export default StepLoan;
